/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */
import PointTool from './tools/PointTool';
import PolylineTool from './tools/PolylineTool';
import DistanceTool from './tools/DistanceTool';
import PenTool from './tools/PenTool';
import PenFillTool from './tools/PenFillTool';
import RectTool from './tools/RectTool';
import PolygonTool from './tools/PolygonTool';
import CircleTool from './tools/CircleTool';
import EllipseTool from './tools/EllipseTool';
import MilitaryArrowTool from './tools/MilitaryArrowTool';
import TextTool from "./tools/TextTool";
import PathMarker from '@/marker/PathMarker';
import FeatureLayer from "@/layer/FeatureLayer";
import { pointInPolygon } from '@/utils/geoUtils';
//
// 涉及重写Polyline 的 onAdd 和 flow 有顺序执行的冲突
import '@/plugins/meature/leaflet-measure-path';
import '@/plugins/meature/leaflet-measure-path.css';
//
let { isArray } = T;
let {
  Marker,
  Polyline,
  Polygon,
  Circle,
  CircleMarker
} = L;
/**
 * 标绘工具-管理器
 */
export default class DrawTool extends FeatureLayer {
  /**
   * 用于回滚
   */
  history = []
  /**
   * 用于前进
   */
  next = []
  /**
   * 当前的绘制编辑对象
   */
  marker
  /**
   * 当前的绘制工具对象
   */
  tool
  /**
   * 当前的绘制工具类
   */
  Tool
  /**
   * 默认配置选项
   */
  options = { editable: true, draggable: true }
  /**
   * 
   * @param dmap 
   */
  addTo(dmap) {
    dmap.on('draw-end', this.onDrawEnd.bind(this));
    return super.addTo(dmap);
  }
  /**
   * 
   * @param {*} marker 
   * @param {*} options 
   * @param {*} data 
   */
  add(marker, options, data) {
    //
    if (options.tooltip) {
      options.tooltip.draggable = true;
    }
    super.add(marker, options, data);
    // 设置为可编辑
    marker.editEnable();
    //
    marker.makeDraggable();
    marker.dragging.enable();
    //
  }

  /**
   * 改变地图工具
   * @param options {tool,feature,tooltip,popup}
   */
  change(options) {
    let that = this;
    if (options) {
      let { dmap, history, next } = that;
      switch (options.tool) {
        case 'clear':
          that.clear();
          break;
        case 'pointer':
          that.reset();
          break;
        case 'go':  // 前进
          let todo = next[next.length - 1];
          if (todo && todo.restore()) {
            next.pop();
          }
          !history.includes(todo) && history.push(todo);
          that.reset();
          break;
        case 'back':// 回滚
          let done = history[history.length - 1];
          if (done && done.reback()) {
            history.pop();
          }
          !next.includes(done) && next.push(done);
          that.reset();
          break;
        default:
          that.start(options);
          break;
      }
      dmap.do('tool-change', { target: that, options: options });
    }
    return that;
  }
  /**
   * 启动绘制
   * @param options {tool:'',feature,tooltip,popup}
   */
  start(options) {
    let that = this;
    let { map } = that;
    let tool = options.tool;
    that.cancel();
    map.dragging.disable();
    (tool = that.get(tool)) && (tool = tool.create(that, options));
    if (tool) {
      let mergeOptions = T.assign({}, that.options, options);
      tool.options.feature.draggable = mergeOptions.draggable;
      tool.options.reable = mergeOptions.reable;
      tool.options.editable = mergeOptions.editable;
      tool.start();
    }
    that.tool = tool;
  }


  /**
   * 获取绘制工具
   * @param tool 
   */
  get(tool) {
    switch (tool) {
      case 'point':
        return PointTool;
      case 'distance':
        return DistanceTool;
      case 'polyline':
        return PolylineTool;
      case "pen":
        return PenTool;
      case "circle":
        return CircleTool;
      case 'ellipse':
        return EllipseTool;
      case "rect":
        return RectTool;
      case "polygon":
        return PolygonTool;
      case 'penfill':
        return PenFillTool;
      case 'militaryArrow':
        return MilitaryArrowTool;
      case 'text':
        return TextTool;
    }
  }
  /**
   * 
   */
  cancel() {
    this.tool && this.tool.cancel();
    this.tool = null;
  }
  /**
   * 重置
   */
  reset() {
    this.cancel();
    this.map.dragging.enable();
    //  map.doubleClickZoom.enable();
  }
  /**
   * 绘制结束
   */
  onDrawEnd(e) {
    // 重置前进内容
    this.next.length = 0;
    //
    let { tool } = this;
    if (tool) {
      // 推进历史
      !this.history.includes(tool) && this.history.push(tool);
      //
      let { options, marker } = tool;
      if (options.searchable) {
        this.dmap.do('search-end', { target: this, event: e, value: this.search(e) });
      }
      // 设置为可编辑
      if (options.editable) {
        T.defer(() => {
          marker.editEnable();
        })
      }
      //
      options.onDrawEnd && options.onDrawEnd(e);
      // 绘制模式
      if (options.multi) {
        // 重复绘制
        tool.cancel();
        tool = this.tool = tool.clone();
        tool.start();
      } else if (options.reable) {
        // 重新绘制
        tool.cancel();
        this.tool = tool;
        tool.start();
      } else {
        // 重置
        this.reset();
      }
    } else {
      this.reset();
    }

  }
  /**
   * 搜索
   */
  search(e) {
    let { marker } = e,
      result = [];
    if (!marker) {
      throw 'search error'
    }
    let { _map: map } = marker
    if (marker instanceof Circle) {
      let { _radius } = marker;
      let center = marker.getLatLng();
      map.eachLayer((layer) => {
        //
        if (layer instanceof Marker || layer instanceof PathMarker) {
          if (map.latLngToLayerPoint(layer.getLatLng()).distanceTo(map.latLngToLayerPoint(center)) < _radius) {
            result.push(layer);
          }
        } else if (layer instanceof Polyline) {
          let latlngs = layer.getLatLngs()
          if (isArray(latlngs[0])) {//todo 
            latlngs = latlngs[0]
          }
          for (let i = 0, len = latlngs.length; i < len; i++) {
            if (map.latLngToLayerPoint(latlngs[i]).distanceTo(map.latLngToLayerPoint(center)) < _radius) {
              result.push(layer);
              break;
            }
          }
        } else if (layer instanceof Polygon) {
          let latlngs = layer.getLatLngs()
          if (isArray(latlngs[0])) {
            latlngs = latlngs[0]
          }
          for (let i = 0, len = latlngs.length; i < len; i++) {
            if (map.latLngToLayerPoint(latlngs[i]).distanceTo(map.latLngToLayerPoint(center)) < _radius) {
              result.push(layer);
              break;
            }
          }
        }
      })
    } else if (marker instanceof Polygon) {
      let { _rings } = marker;
      map.eachLayer(layer => {
        if (layer instanceof Marker || layer instanceof CircleMarker) {
          if (pointInPolygon(map.latLngToLayerPoint(layer.getLatLng()), _rings[0])) {
            result.push(layer);
          }
        } else if (layer instanceof Polyline) {
          let latlngs = layer.getLatLngs();
          if (isArray(latlngs[0])) {//todo 
            latlngs = latlngs[0]
          }
          for (let i = 0, len = latlngs.length; i < len; i++) {
            if (pointInPolygon(map.latLngToLayerPoint(latlngs[i]), _rings[0])) {
              result.push(layer);
              break;
            }
          }
        } else if (layer instanceof Polygon) {
          let latlngs = layer.getLatLngs()
          if (isArray(latlngs[0])) {
            latlngs = latlngs[0]
          }
          for (let i = 0, len = latlngs.length; i < len; i++) {
            if (pointInPolygon(map.latLngToLayerPoint(latlngs[i]), _rings[0])) {
              result.push(layer);
              break;
            }
          }
        }
      })
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./src/plugins/DrawTool.js